import { AsyncIterableX } from '@reactivex/ix-esnext-esm/asynciterable/asynciterablex';
import { concat } from '@reactivex/ix-esnext-esm/asynciterable/concat';
import { InvalidStorageStackItemEnumeratorError } from './errors';
export class StackItemEnumerator {
    constructor(enumerator) {
        this.enumerator = enumerator;
        this.mutableDone = false;
    }
    get done() {
        return this.mutableDone;
    }
    equals(other) {
        return this === other;
    }
    async next() {
        if (!this.mutableDone) {
            const result = await this.enumerator.next();
            this.mutableCurrent = result.done ? undefined : result.value;
            this.mutableDone = !!result.done;
            if (this.mutableDone) {
                return false;
            }
            return true;
        }
        return false;
    }
    value() {
        const { mutableCurrent } = this;
        if (mutableCurrent === undefined) {
            throw new InvalidStorageStackItemEnumeratorError();
        }
        return mutableCurrent.value;
    }
    concat(other) {
        const iterable = concat(AsyncIterableX.from(this.enumerator), AsyncIterableX.from(other.enumerator));
        return new StackItemEnumerator(iterable[Symbol.asyncIterator]());
    }
}

//# sourceMappingURL=StackItemEnumerator.js.map
